import React from "react";
import { ExternalLink } from "lucide-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white p-4">
      <div className="container mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div>
            <p>© 2025 3i CryptoRate - For informational purposes only</p>
            <p className="text-gray-400 text-xs mt-1">
              Not financial advice. Trade at your own risk.
            </p>
          </div>

          <div className="mt-4 md:mt-0 flex items-center">
            <p className="text-gray-300 text-sm mr-4">
              <a
                href="https://3iapps.com.br/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center hover:text-violet-300 transition-colors"
              >
                By 3i Organization <ExternalLink size={14} className="ml-1" />
              </a>
            </p>

            <p className="text-gray-300 text-sm mr-4">
              <a
                href="https://efficacious-water-9e0.notion.site/Termos-de-Uso-e-Pol-tica-de-Privacidade-3iCryptoRate-1c1dbc4d8d1180f8bdf2e04ae8006cc8?pvs=4"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center hover:text-violet-300 transition-colors"
              >
                Privacy Policy <ExternalLink size={14} className="ml-1" />
              </a>
            </p>

            <div className="flex space-x-4">
              <a
                href="https://instagram.com/3iorganization"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-violet-300 transition-colors"
              >
                <FontAwesomeIcon
                  icon={faInstagram}
                  style={{ width: "22px", height: "22px" }}
                />
              </a>
              <a
                href="https://twitter.com/3iOrganization"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-violet-300 transition-colors"
              >
                <FontAwesomeIcon
                  icon={faTwitter}
                  style={{ width: "22px", height: "22px" }}
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
